// @flow
import type { Action } from './store.type';

export const CHANGE_SEMANTIC_REQUEST = 'CHANGE_SEMANTIC_REQUEST';
type CHANGE_SEMANTIC_REQUEST_TYPE = 'CHANGE_SEMANTIC_REQUEST';

export const CHANGE_SEMANTIC_SUCCESS = 'CHANGE_SEMANTIC_SUCCESS';
type CHANGE_SEMANTIC_SUCCESS_TYPE = 'CHANGE_SEMANTIC_SUCCESS';

export const CHANGE_SEMANTIC_FAILURE = 'CHANGE_SEMANTIC_FAILURE';
type CHANGE_SEMANTIC_FAILURE_TYPE = 'CHANGE_SEMANTIC_FAILURE';

export const GET_SEMANTIC_REQUEST = 'GET_SEMANTIC_REQUEST';
type GET_SEMANTIC_REQUEST_TYPE = 'GET_SEMANTIC_REQUEST';

export const GET_SEMANTIC_SUCCESS = 'GET_SEMANTIC_SUCCESS';
type GET_SEMANTIC_SUCCESS_TYPE = 'GET_SEMANTIC_SUCCESS';

export const GET_SEMANTIC_FAILURE = 'GET_SEMANTIC_FAILURE';
type GET_SEMANTIC_FAILURE_TYPE = 'GET_SEMANTIC_FAILURE';

export const TRIGGER_SYNC_SEMANTIC = 'TRIGGER_SYNC_SEMANTIC';
export const STOP_TRIGGER_SYNC_SEMANTIC = 'STOP_TRIGGER_SYNC_SEMANTIC';

// Check live theme supported
type SemanticSuccess = {};
type SemanticFailure = {
  error: any
};
type GetSemanticRequestAction = Action<GET_SEMANTIC_REQUEST_TYPE, null>;

type GetSemanticSuccessAction = Action<
  GET_SEMANTIC_SUCCESS_TYPE,
  SemanticSuccess
>;

type GetSemanticFailureAction = Action<
  GET_SEMANTIC_FAILURE_TYPE,
  SemanticFailure
>;

type ChangeSemanticRequestAction = Action<CHANGE_SEMANTIC_REQUEST_TYPE, null>;

type ChangeSemanticSuccessAction = Action<
  CHANGE_SEMANTIC_SUCCESS_TYPE,
  SemanticSuccess
>;

type ChangeSemanticFailureAction = Action<
  CHANGE_SEMANTIC_FAILURE_TYPE,
  SemanticFailure
>;

export type SemanticAction =
  | GetSemanticRequestAction
  | GetSemanticSuccessAction
  | GetSemanticFailureAction
  | ChangeSemanticRequestAction
  | ChangeSemanticSuccessAction
  | ChangeSemanticFailureAction;

export type SemanticState = {
  settingGetting: boolean;
  updateSubmitting: boolean;
  settings: boolean;
  success: boolean;
  checkSyncSemantic: number;
  showSyncSuccess: boolean;
};
